<div class="container">
  <mat-card>
    <mat-card-header>
      <mat-card-title>
        <div class="row">
          <div class="col-12 text-center">
            <img src="../../../../assets/img/tonic-dots.png" 
                 alt="Tonic logo" 
                 width="50">
          </div>
          <h1 class="fw-semibold col-12 text-center">
            {{installation?.name ? installation?.name : "No Store Loaded" | titlecase}}
          </h1>
        </div>
      </mat-card-title>
      <mat-card-subtitle class="justify-content-center">Upload Your Documents</mat-card-subtitle>
    </mat-card-header>

    <mat-card-content class="upload-zone">
      <div style="padding-bottom: 10px;">
        <div class="installation-row">
          <b>Type</b>
          <b>Name</b>
          <b>Action</b>
        </div>
      </div>
      <div *ngFor="let task of tasks">
        <ng-template #menu [ngIf]="tasks.length > 0 && task.type === 1">
          <div class="installation-row">
            <span>Menu</span>
            <span class="title">{{task.name | titlecase}}<mat-icon *ngIf="task.uploaded" style="color: green">check_circle</mat-icon></span>
            <button
              mat-icon-button
              matTooltip="Upload Menu"
              matTooltipShowDelay="2000"
              (click)="openUpload(tasks, 'upload_menu', installation)">
              <mat-icon>file_upload</mat-icon>
            </button>
         </div>
        </ng-template>

        <ng-template #staff [ngIf]="tasks.length > 0 && task.type === 2">
          <div class="installation-row">
            <span>Staff</span>
            <span class="title">{{task.name | titlecase}}<mat-icon *ngIf="task.uploaded" style="color: green">check_circle</mat-icon></span>
            <button
              mat-icon-button
              matTooltip="Upload Staff"
              matTooltipShowDelay="2000"
              (click)="openUpload(task, 'upload_staff', installation)">
              <mat-icon>file_upload</mat-icon>
            </button>
         </div>
        </ng-template>

        <ng-template #layout [ngIf]="tasks.length > 0 && task.type === 3">
          <div class="installation-row">
            <span>Layout</span>
            <span class="title">{{task.name | titlecase}}<mat-icon *ngIf="task.uploaded" style="color: green">check_circle</mat-icon></span>
            <button
              mat-icon-button
              matTooltip="Upload Layout"
              matTooltipShowDelay="2000"
              (click)="openUpload(task, 'upload_layout', installation)">
              <mat-icon>file_upload</mat-icon>
            </button>
          </div>
        </ng-template>

        <ng-template #payment [ngIf]="tasks.length > 0 && task.type === 4">
          <div class="installation-row">
            <span>Payment</span>
            <span class="title">{{task.name | titlecase}}<mat-icon *ngIf="task.uploaded" style="color: green">check_circle</mat-icon></span>
            <button
              mat-icon-button
              matTooltip="Upload Payment"
              matTooltipShowDelay="2000"
              (click)="openUpload(task, 'upload_payment', installation)">
              <mat-icon>file_upload</mat-icon>
            </button>
          </div>
        </ng-template>

        <ng-template #customers [ngIf]="tasks.length > 0 && task.type === 5">
          <div class="installation-row">
            <span>Customer</span>
            <span class="title">{{task.name | titlecase}}<mat-icon *ngIf="task.uploaded" style="color: green">check_circle</mat-icon></span>
            <button
              mat-icon-button
              matTooltip="Upload Customer"
              matTooltipShowDelay="2000"
              (click)="openUpload(task, 'upload_customer', installation)">
              <mat-icon>file_upload</mat-icon>
            </button>
         </div>
        </ng-template>

        <ng-template #inventory [ngIf]="tasks.length > 0 && task.type === 6">
          <div class="installation-row" >
            <span>Inventory</span>
            <span class="title">{{task.name | titlecase}}<mat-icon *ngIf="task.uploaded" style="color: green">check_circle</mat-icon></span>
            <button
              mat-icon-button
              matTooltip="Upload Inventory"
              matTooltipShowDelay="2000"
              (click)="openUpload(task, 'upload_inventory', installation)">
              <mat-icon>file_upload</mat-icon>
            </button>
         </div>
        </ng-template>

      </div>
    </mat-card-content>
  </mat-card>
</div>
